
import React from "react";
import Fade from 'react-reveal/Fade';
import { BsPlusCircleDotted } from "react-icons/bs";
import { categories } from "../../data/Data";
import useAuth from "../../Hooks/useAuth";
import { HashLink } from "react-router-hash-link";
const Categories = () => {
  const {showDummyImage} = useAuth()
  return (
    <section className="categories">
      <div className="container">
        <div className="categories-items">
          {categories.map((ele,i) => {
            const { id, title, image, icon } = ele;
            return (
              <Fade key={i}>
                <HashLink to="/explore/#header">
                  <figure className="categories-item" key={id}>
                  <div className="categories-item-img">
                    <img
                      src={require(`${process.env.REACT_APP_CATEGORIES_IMAGE}${image}`)}
                      alt={image}
                      onError={({currentTarget},imageSize='148X148')=>showDummyImage({currentTarget},imageSize)}
                    />
                    {icon && (
                      <div className="categories-item-img-overlay">
                        <button>
                          <BsPlusCircleDotted />
                        </button>
                      </div>
                    )}
                  </div>
                  <figcaption> {title}</figcaption>
                    </figure>
                </HashLink>
              </Fade>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Categories;
